import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/shared/Footer';

function NotFoundPage() {
  return (
    <div className="App App--not-found">
      <section className="subpage-content section-light-dark d-flex align-items-center">
        <div className="container py-10">
          <h1 className="mb-4">Page not found</h1>
          <p className="mb-5">
            The page you are looking for does not exist or the link is incorrect.
          </p>
            <h3>
                <Link to="/" className="text-decoration-underline text-white">
                    Back to home
                </Link>
            </h3>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default NotFoundPage;
